import { Container, Row } from "reactstrap";
import { BonusUi, CreativeCardTitle } from "../../../constants";
import AbsolutePrimary from "./AbsolutePrimary";
import AbsoluteSecondary from "./AbsoluteSecondary";
import BorderBottom from "./BorderBottom";
import BorderLeft from "./BorderLeft";
import BorderPrimary from "./BorderPrimary";
import BorderRight from "./BorderRight";
import BorderSecondary from "./BorderSecondary";
import BorderTop from "./BorderTop";
import BorderWarning from "./BorderWarning";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const CreativeCardContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CreativeCardTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BorderLeft />
          <BorderRight />
          <BorderTop />
          <BorderBottom />
          <BorderPrimary />
          <BorderWarning />
          <BorderSecondary />
          <AbsolutePrimary />
          <AbsoluteSecondary />
        </Row>
      </Container>
    </>
  );
};
export default CreativeCardContainer;
